import PageTemplate from "../components/common/PageTemplate";
import Profile from "../screen/profile/Profile";

const ProfilePage = () => {
  return (
    <PageTemplate
      mainComponent={<Profile />}
      noPadding={true}
      logo={"Profile"}
    />
  );
};

export default ProfilePage;
